import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'

// Component
import { Button, Icon, Input, List, Modal, Table, message, Tooltip, InputNumber } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import Wrapper from '../../../../../common/component/Wrapper'

// Func common 
import * as RateCodeService from '../../../../../../../services/rateCodeService'
import { parseRatingListRequestParams } from '../../../../../../../utils/commonUtils'
import AntSelect, { AntOption } from '../../../../../common/component/AntSelect'
import { capitalizeFirstLetter, checkUndefine, formatMoney, vietnameseStringToUnicode, formatValidation, multipleValidate, getPathWithParams} from '../../../../../../../helpers/functions'
import { SurchargeTour } from '../../../../../../../models/Order'
import { DatePickerComponent, FormWrapperInputComponent } from '../../../../../common/component/Index'
import * as Func from '../../../../../../../helpers/functions';

// Style
import './SurchargeTour.less'
import { DATE_TIME_FORMAT, PATHS } from '../../../../../../../constants/Define'
import { Link } from 'react-router-dom'
import moment from 'moment'

const SurchargeTourDetail = (props) => {

    const { 
        isOpen,
        destroySurcharge,
        infoItem,
        t,
        createSurchargeDetail,
        getSurchargeDetail,
        updateSurchargeDetail,
        setSurchargeDetail,
        orderState
    } = props

    const [dataSurcharge, setDataSurchage] = useState(new SurchargeTour())
    const [validation, setValidation] = useState({})
    const [rateCodes, setRateCodes] = useState([])
    const [rateCodeSelected, setRateCodeSelected] = useState(null)
    const [quantitySelected, setQuantitySelected] = useState(1)
    const [usingDateSelected, setUsingDateSelected] = useState(null)
    const [listRateCodeSelected, setListRateCodeSelected] = useState([])
    const [isPreview, setIsPreview] = useState(false)
    const [action, setAction] = useState('create')
    const [errorInventory, setErrorInventory] = useState("");

    useState(() => {
        if(!!infoItem && infoItem.id) {
            getSurchargeDetail(infoItem.id)
            setAction('update')
        }
    }, [infoItem])

    useEffect(() => {
        if(orderState.detail.surcharge && action === 'update') {
            setDataSurchage(orderState.detail.surcharge)
            setListRateCodeSelected(orderState.detail.surcharge.rateCodes)
        }
    }, [orderState])

    useEffect(() => {
        if(isOpen && rateCodes.length === 0) {
            getRateCodes()
        }
    }, [isOpen])

    const handleOk = () => {
        if(isPreview) {
            const rateCodes = listRateCodeSelected.reduce((prev, current) => [...prev, {rateCode: current.rateCode.code, quantity: current.quantity, usingDate: moment(current.usingDate, DATE_TIME_FORMAT.SHORT_DATE).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT)}], [])
            const dataSubmit = {
                ...dataSurcharge,
                ...infoItem,
                rateCodes
            }
            
            if(action === 'create') {
                createSurchargeDetail(new SurchargeTour(dataSubmit))
            } else {
                updateSurchargeDetail({ surcharge: new SurchargeTour(dataSubmit), props: { orderItemType: "tours" } })
            }

            resetData()
        }
    }

    const handleCancel = () => {
        if(isPreview) {
            return setIsPreview(false)
        }
        resetData()
    }

    const resetData = () => {
        setDataSurchage(new SurchargeTour())
        setValidation({})
        setRateCodes([])
        setRateCodeSelected(null)
        setListRateCodeSelected([])
        setIsPreview(false)
        setAction('create')

        setSurchargeDetail()
        
        destroySurcharge()
    }

    const showPreview = () => {
        if(validate()) {
            if(listRateCodeSelected.length === 0) {
                return message.error('Vui lòng thêm mã giá!')
            }
            setIsPreview(true)
        }
    }

    const validate = () => {
        let validate = {
            required: {
                ftCode: formatValidation(t('validation.statusCode.code.1'), t(`item.cashFlow.ftCode`)),
                // pmsTransactionCode: formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.pmsTransactionCode`))
            }
        };

        let valueValidate = {};

        const result = multipleValidate(dataSurcharge, validate, valueValidate);
        setValidation(result);
        return Object.keys(result).length < 1;
    }

    const addDataRateCode = async () => {
        await getRateCodes();

        const isExistRateCode = listRateCodeSelected.filter(item => item.rateCode.id === rateCodeSelected)
        if(isExistRateCode.length > 0) {
            return message.error('Mã giá này đã tồn tại trong danh sách !')
        }
        if(!rateCodeSelected || !quantitySelected || !usingDateSelected){
            return message.error('Không được bỏ trống field !')
        }

        const usingDateExport = moment(usingDateSelected).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT);
        const rateItem = rateCodes.find(rc => rc.id === rateCodeSelected);
        if(await checkStock(rateItem.code, quantitySelected, usingDateExport)){
            if(rateCodeSelected){
                const usingDate = moment(usingDateSelected).format(DATE_TIME_FORMAT.SHORT_DATE);
                setListRateCodeSelected([...listRateCodeSelected, {rateCode: rateItem, quantity: quantitySelected, usingDate: usingDate}])
            }
        }
    }

    const removeDataRateCode = (index) => {
        const list = [...listRateCodeSelected]
        list.splice(index, 1)
        setListRateCodeSelected(list)
    }

    const getRateCodes = async () => {
        const params = parseRatingListRequestParams({
            pageSize: 15,
            tourLineItemTicketId: infoItem.productVariantId,
            isActive: true
        })
        const listRateCode = await RateCodeService.getRateCodeList({ ...params });
        setRateCodes(listRateCode.result)
        return;
        const totalPage = Math.ceil(parseInt(listRateCode.totalCount) / parseInt(listRateCode.pageSize))
        if(listRateCode.result.length > 0 && totalPage > 1) {
            let dataAllRateCode = [...listRateCode.result]
            for(let page = 2; page <= totalPage; page++) {
                const nextData = await RateCodeService.getRateCodeList({ ...params, pageIndex: page });
                dataAllRateCode = [...dataAllRateCode, ...nextData.result]
            }
            setRateCodes(dataAllRateCode)
        }
    }

    const checkStock = async (rateCode, quantity, usingDate) => {
        setErrorInventory("");
        const params = [
            ...(listRateCodeSelected || []).map(x=> ({
                orderId: infoItem.orderId,
                itemVariantId: infoItem.orderIditemVariantId,
                rateCode: x.rateCode?.code,
                quantity: x.quantity,
                usingDate: x.usingDate
            })),
            {
            orderId: infoItem.orderId,
            itemVariantId: infoItem.orderIditemVariantId,
            rateCode: rateCode,
            quantity: quantity,
            usingDate: usingDate
          }]
        const data = await RateCodeService.checkStock(params);
        if(data?.errors?.length){
            setErrorInventory(t(`validation.statusCode.code.${data?.errors[0].code}`))
            return false;
        }else{
            setErrorInventory("");
            return true;
        }
    }

    const selectFilterSearch = async (input, option) => {
        const optionText = vietnameseStringToUnicode(option.props.children[0].toLowerCase());
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    const onChangeRateCode = (value) => {
        setRateCodeSelected(value)
    }

    const onSearchRateCode = (value) => {
        Func.lastRequest(500).then(async () => {
            const params = parseRatingListRequestParams({
                pageSize: 10,
                tourLineItemTicketId: infoItem.productVariantId,
                isActive: true,
                searchTerm: value,
            })
            const listRateCode = await RateCodeService.getRateCodeList({ ...params });
            setRateCodes(listRateCode.result);
        });

    }

    const onChangeInput = (key, value) => {
        setDataSurchage({
            ...dataSurcharge,
            [key]: value.trimLeft()
        })
    }

    const renderRateCodeProduct = (rateCodeProducts, anotherText = '') => {
        return rateCodeProducts.map((product, index) => (
            <span key={index}>{product.code} ({formatMoney(product.cost * product.coefficient)}){(index !== rateCodeProducts.length - 1) && anotherText}</span>
        ))
    }

    const columns = useMemo(() => {
        return  [
            {
              title: t(`item.cashFlow.amount`),
              dataIndex: 'cost',
              key: 'cost',
              render: (value, record) => formatMoney(checkUndefine(value))
            },
            {
              title: t(`item.cashFlow.orderCode`),
              dataIndex: 'orderCode',
              key: 'orderCode',
            },
            {
              title: t(`item.cashFlow.transactionName`),
              dataIndex: 'type',
              key: 'type',
            },
          ];
    }, [])



    const totalCost = listRateCodeSelected.reduce((prevValue, currValue) => prevValue + currValue.rateCode.sellCost*currValue.quantity, 0)

    const dataTotal = [{
        id: '',
        cost: totalCost,
        orderCode: !!infoItem && infoItem.orderCode,
        type: 'phụ thu'
    }]

    const listReview = listRateCodeSelected.reduce((prevValue, currValue) => [
        ...prevValue, 
        ...currValue.rateCode.rateCodeProducts.map(item => ({
            id: '',
            cost: `-${item.cost * item.coefficient * currValue.quantity}`,
            orderCode: '',
            type: 'Chuyển tiền cơ sở'
            }))
        ], 
        [])

    return (
        <Modal
          title="Lựa chọn mã giá phụ thu"
          visible={isOpen}
          onOk={isPreview ? handleOk : showPreview}
          onCancel={handleCancel}
          cancelText={isPreview ? t('action.back') : t('action.cancel')}
          okText={isPreview ? t('action.confirm') : t(`action.${action}`)}
          width={ 900 }
        >
            {
                !isPreview ?
                <Wrapper className="row search-rate-code">
                    <Wrapper className="col-md-6 m-b">
                        <AntSelect className="select-destination"
                            showArrow showSearch
                            placeholder={ capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ratecode.title")).toLowerCase()) }
                            value={ rateCodeSelected }
                            onChange={ onChangeRateCode }
                            onSearch={onSearchRateCode}
                            style={ { width: '100%' } }
                            filterOption={ selectFilterSearch }
                        >
                            { rateCodes.map(rateCode => (
                                <AntOption key={ rateCode.id } value={ rateCode.id }>{ `${rateCode.code} | ${rateCode.name} | ${formatMoney(rateCode.sellCost)}` } </AntOption>
                            )) }
                        </AntSelect>
                    </Wrapper>
                    <Wrapper className="col-md-2 m-b quantity-surcharge">
                        <span className="title-surcharge">Số lượng</span>
                        <InputNumber placeholder=""
                            name={`quantity`}
                            onChange={(e) => setQuantitySelected(e)}
                            value={checkUndefine(quantitySelected)} 
                            min={1}
                            max={5} 
                        />
                    </Wrapper>
                    <Wrapper className="col-md-2 m-b quantity-surcharge">
                        <span className="title-surcharge">Ngày sử dụng</span>
                        <DatePickerComponent className={`form-control applyDates w100-percent`}
                            hmsComponent={`DatePicker`}
                            format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            name={`usingDate`}
                            onChange={(e) => setUsingDateSelected(e.fullValue)}
                            value={usingDateSelected}
                        />
                    </Wrapper>
                    <Wrapper className="col-md-2 m-b">
                        <Button className="btn btn-primary ml-3" onClick={async () => {await addDataRateCode()}}>
                            Thêm
                        </Button>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        {!!errorInventory && (
                            <div className='colorRed mb-4'>{errorInventory}</div>
                        )}
                        {
                            listRateCodeSelected.length > 0 &&
                            <List
                                className="list-rate-code"
                                bordered
                                dataSource={listRateCodeSelected}
                                renderItem={(item, index) => (
                                    <List.Item 
                                        actions={
                                            [
                                                <Link to={getPathWithParams(PATHS.RATECODE.DETAIL.path, { id: item.rateCode.id })} target="_blank" key="list-loadmore-edit">xem</Link>,
                                                <span key="list-loadmore-more" onClick={() => removeDataRateCode(index)}>xóa</span>
                                            ]
                                        }
                                    >
                                        <div className="item-rate-code">
                                            <span className="font-weight-bold">{item.rateCode.code} ({formatMoney(item.rateCode.sellCost)})</span>
                                            {
                                                !!item.rateCode.rateCodeProducts.length && 
                                                <Tooltip title={renderRateCodeProduct(item.rateCode.rateCodeProducts, ' - ')}>
                                                    {/* <span class="rate-code-name">{item.name}</span> */}
                                                    <p className="m-b-0 text-popup">{renderRateCodeProduct(item.rateCode.rateCodeProducts)}</p>
                                                </Tooltip>
                                            }
                                        </div>
                                        <div>SL <span className="font-weight-bold">{item.quantity}</span></div>
                                        <div><span className="font-weight-bold">{item.usingDate}</span></div>
                                    </List.Item>
                                )}
                            />
                        }
                        { listRateCodeSelected.length > 0 && <p className="total-amount">Tổng tiền: {formatMoney(totalCost)}</p> }
                    </Wrapper>
                    <Wrapper className="col-md-12 m-b">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.surcharge.note`)}
                        >
                            <TextArea
                                className="form-control" 
                                name="note" 
                                rows={3}
                                onChange={(e) => onChangeInput('note', e.target.value)}
                                value={checkUndefine(dataSurcharge.note)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className='col-md-12'>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={dataSurcharge.ftCode}
                            validation={validation.ftCode}
                            labelTitle={t(`item.surcharge.ftCode`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`ftCode`}
                                onChange={(e) => onChangeInput('ftCode', e.target.value)}
                                value={checkUndefine(dataSurcharge.ftCode)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    {/* <Wrapper className='col-md-12'>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={dataSurcharge.pmsTransactionCode}
                            validation={validation.pmsTransactionCode}
                            labelTitle={t(`item.surcharge.pmsTransactionCode`)}
                            className="with-fix"
                        >
                            <Input type="text"
                                autoComplete="off"
                                placeholder=""
                                name="pmsTransactionCode"
                                onChange={ (e) => onChangeInput('pmsTransactionCode', e.target.value) }
                                value={checkUndefine(dataSurcharge.pmsTransactionCode)}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper> */}
                </Wrapper> 
                :
                <Wrapper>
                    <h4 className="m-b">Lưu ý!</h4>
                    <p className="m-b">Việc thêm phụ thu vào sản phẩm là hành động quan trọng. Các sản phẩm phụ thu sẽ tiến hành redeem ngay lập tức hãy đảm bảo thông tin chính xác.</p>
                    <p>Danh sách dòng tiền sẽ phát sinh sau hành động.</p>
                    <Table
                        dataSource={[...dataTotal, ...listReview]} 
                        rowKey={(record, index) => index}
                        columns={columns} 
                        pagination={{ defaultPageSize: 5 }}
                    />
                </Wrapper>
            }
            
        </Modal>
    )
}

export default withTranslation()(SurchargeTourDetail)